"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "trevi": {
    "0772ecab": [{
      "hkey": "19b1998a",
      "slug": "centro-borgo",
      "name": "Centro-Borgo",
      "primary": true,
      "skipSearch": false
    }],
    "borgo": [{
      "hkey": "19b1998a",
      "slug": "centro-borgo",
      "name": "Centro-Borgo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "24ab75bc": [{
      "hkey": "f6633ed5",
      "slug": "trevi",
      "name": "Trevi",
      "primary": true,
      "skipSearch": false
    }],
    "parrano": [{
      "hkey": "f6633ed5",
      "slug": "trevi",
      "name": "Trevi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "563090d0": [{
      "hkey": "f6633ed5",
      "slug": "trevi",
      "name": "Trevi",
      "primary": true,
      "skipSearch": false
    }],
    "ponze": [{
      "hkey": "f6633ed5",
      "slug": "trevi",
      "name": "Trevi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;